module.exports = __webpack_public_path__ + "./img/PedidosDetalle.1ae2449259f5272fce92eebc4c508349.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/Help/PedidosDetalle.png
// module id = ./public/img/Help/PedidosDetalle.png
// module chunks = 0